import React from 'react';
import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { TitleStyle } from './style';
import { DEFAULT_APP_TITLE_HEIGHT } from 'config/const';
import { flexVertical, flexCenter } from 'styles';

function TitleBox({ title, titleId }) {
  const intl = useIntl();
  return (
    <Box sx={TitleStyle}>
      <Box
        height={DEFAULT_APP_TITLE_HEIGHT}
        sx={{ ...flexCenter, ...flexVertical }}
      >
        <Typography variant="subtitle1">
          {titleId ? intl.formatMessage({ id: titleId }) : title}
        </Typography>
      </Box>
    </Box>
  );
}

TitleBox.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  titleId: PropTypes.string,
};

export default TitleBox;
